export default {
  zh: {
    payCompleted: '支付已完成',
    airwallex: '支付宝',
    redirect: '正在跳转至',
    wait: '，请稍后...',
    checkout: '充值',
    purchasePackage: '购买套餐',
    devices: '台设备',
    upgrade: '升级',
    type: {
      payment: 'VIP',
      svip: 'SVIP'
    },
    member: '会员',
    priceDifference: '（差价）',
    subscribeDescribe: '订阅套餐，到期后自动续期，可随时前往支付平台取消',
    subscribeNote: '注：自动续费暂不支持微信和支付宝支付',
    trierSubscribeNotice: '您剩余的天数将折算为等值的套餐天数',
    payNow: '立即购买',
    upgradeFee: '升级费用',
    leftBracket: '（',
    rightBracket: '）',
    remainingTime: '剩余时长',
    D: '天',
    H: '小时',
    m: '分钟',
    subTotal: '合计',
    chooseMethods: '选择支付',
    notFindOrder: '订单未找到',
    wechatPay: '请打开手机微信扫一扫支付',
    paymentAmount: '支付金额',
    USD: 'USD$',
    CNY: '￥',
    name: '用户名：',
    cardNumber: '卡号：',
    useNewCard: '使用新卡',
    useExistCard: '使用此卡',
    stripe_title: '信用卡',
    purchase_tips: '单价是按实际使用时间计算的平均价格',
    cardError: '信用卡不为空',
    cardDetails: '您的信用卡信息',
    loadFail: '加载失败，请点击重试'
  },
  en: {
    payCompleted: 'Payment Completed',
    airwallex: 'Alipay',
    redirect: 'Redirecting to ',
    wait: ', please wait',
    checkout: 'Checkout',
    purchasePackage: 'Purchase Plan',
    devices: 'Device | Devices',
    upgrade: 'Upgrade',
    type: {
      payment: 'VIP',
      svip: 'SVIP'
    },
    member: ' ',
    priceDifference: '(Price Difference)',
    subscribeDescribe: 'Subscription will be auto-renewed upon expiration, you can visit payment platform to cancel it at anytime',
    subscribeNote: 'Note: Wechat pay and Alipay are unavailable for auto payment',
    trierSubscribeNotice: 'Your remaining time will be converted to equivalent package service time',
    payNow: 'Pay Now',
    upgradeFee: 'Upgrade Fee',
    leftBracket: '(',
    rightBracket: ')',
    remainingTime: 'Remaining Time',
    D: 'day|days',
    H: 'hour|hours',
    m: 'minute|minutes',
    subTotal: 'Subtotal',
    chooseMethods: 'Select a Payment Method',
    notFindOrder: 'This order does not exist!',
    wechatPay: 'Please open WeChat Scan QR Code to make payment',
    paymentAmount: 'Payment amount',
    USD: 'USD$',
    CNY: '￥',
    name: 'Name:  ',
    cardNumber: 'Card Number:  ',
    useNewCard: 'Use New Card',
    useExistCard: 'Use This Card',
    stripe_title: 'Credit Card',
    purchase_tips: 'The monthly price is the average price calculated based on the actual service time',
    cardError: 'Credit Card is required',
    cardDetails: 'YOUR CREDIT CARD DETAILS',
    loadFail: 'Failed to load, click to retry'
  }
}



// WEBPACK FOOTER //
// ./src/components/payOrder/lang.js